import { Currency } from '@/core/currency/interfaces';

const KGS: Currency = {
    name: 'Kyrgyzstani Som',
    demonym: 'Kyrgyzstani',
    majorSingle: 'Som',
    majorPlural: 'Som',
    codeNumeric: '417',
    symbol: 'с',
    symbolNative: 'с',
    minorSingle: 'Tyiyn',
    minorPlural: 'Tyiyn',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'KGS',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default KGS;
